import { Link } from "react-router-dom";
import AppShell from "@/components/AppShell";
import { Button } from "@/components/ui/button";
import { ShieldOff } from "lucide-react";

export default function AccessDeniedPage() {
  return (
    <AppShell>
      <div className="max-w-2xl mx-auto py-16 text-center" data-testid="access-denied-page">
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-amber-50 mb-6">
          <ShieldOff className="h-8 w-8 text-amber-600" />
        </div>
        <div className="ntn-eyebrow text-amber-700 mb-3">Access denied</div>
        <h1 className="ntn-h1">This area isn't available for your role</h1>
        <p className="ntn-body mt-3 text-[#4A5568]">
          Your account doesn't have permission to view this page. If you believe this is
          a mistake, please contact your NTN account manager — client user permissions
          are managed by NTN.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link to="/dashboard">
            <Button className="bg-[#0A192F] hover:bg-[#0A192F]/90 rounded-sm h-11 px-6" data-testid="access-denied-dashboard">
              Back to dashboard
            </Button>
          </Link>
          <Link to="/account">
            <Button variant="outline" className="rounded-sm h-11 px-6" data-testid="access-denied-account">
              View my access
            </Button>
          </Link>
        </div>
      </div>
    </AppShell>
  );
}
